module.exports = __webpack_public_path__ + "static/media/pricing3.759e2191.jpg";